<!--
 * @Date: 2022-07-07 19:35:08
 * @LastEditTime: 2022-07-21 20:05:06
 * @FilePath: /vue-medweb/packages/vue-m-vaccine-prefecture/src/views/components/Card.vue
 * @Description: 疫苗列表卡片
-->
<template>
  <div id="list-wrap" class="list-wrap">
    <div class="card-wrap">
      <div
        v-for="(item, index) in vaccineList"
        :key="index"
        class="card-content-wrap"
        @click="jumpToDetail(item.shop_spu_id)"
      >
        <img :src="item.img || defaultImgUrl" alt="" class="icon" />
        <div class="card-content">
          <div class="title">{{ item.title }}</div>
          <div class="content-detail">
            <div class="second-line">
              <div class="price">
                <span>¥{{ item.price }}</span>
                <span v-if="item.scribing_price" class="scribing-price"
                  >¥{{ item.scribing_price }}</span
                >
              </div>

              <div class="order-btn">去订购</div>
            </div>
            <div class="third-line">
              <span>{{ item.shop_name }}</span>
              <span>{{ item.sale_num }}人已预约</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="end-tip">- 到底啦 -</div>
  </div>
</template>

<script>
import { defaultImgUrl } from '@/utils/index';

export default {
  name: 'Card',
  props: {
    vaccineList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      defaultImgUrl,
    };
  },
  methods: {
    jumpToDetail(spu_id) {
      window.location.href = `${window.location.origin}/v-m-mall/product/shop-spu/${spu_id}?#OPEN_NEW_WIN`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@@/styles/mixin.scss';
.list-wrap {
  .card-wrap {
    padding: 0 rem(15);
    background: #fff;
    .card-content-wrap {
      display: flex;
      align-items: space-between;
      justify-content: space-between;
      width: 100%;
      height: rem(121);
      padding: rem(15) 0;
      text-align: left;
      &:not(:last-of-type) {
        @include border-bottom-1px();
      }
    }
    .icon {
      flex-basis: rem(90);
      height: rem(90);
      background: #eee;
      border-radius: rem(4);
    }
    .card-content {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      width: rem(243);
      height: rem(90);
      margin-left: rem(12);
      .title {
        font-size: rem(15);
        line-height: rem(20);
        @include multiple-ellipsis();
      }
    }
    .second-line,
    .third-line {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .price {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        padding-top: rem(2);
        color: #ff6134;
        font-weight: 500;
        font-size: rem(17);
      }
      .scribing-price {
        margin-left: rem(5);
        color: #c2c2c2;
        font-weight: normal;
        font-size: rem(12);
        text-decoration: line-through;
      }
      .order-btn {
        padding: rem(4) rem(10);
        color: #fff;
        font-size: rem(12);
        background: #39d167;
        border-radius: rem(12);
      }
    }
    .third-line {
      margin-top: rem(10);
      span {
        color: #999;
        font-size: rem(12);
      }
    }
  }
  .end-tip {
    width: 100%;
    height: rem(54);
    padding: 0 rem(-15);
    color: #999;
    font-size: rem(12);
    line-height: rem(54);
    text-align: center;
  }
}
</style>
